import type { BlockUIDesignTokens, BlockUITokenSections } from '@primeuix/themes/types/blockui';

export const root: BlockUITokenSections.Root = {
    borderRadius: '{content.border.radius}'
};

export const css: BlockUITokenSections.CSS = /*css*/ ``;

export default {
    root,
    css
} satisfies BlockUIDesignTokens;
